import {
  Group,
  UPDATE_ASSETS_GROUPS,
  useCurrentWorkspace,
} from '@gripp/shared-logic';
import { GroupAssignmentColumn } from '../../shared/components/groups/groupAssignmentColumn';

type GroupsButtonProps = {
  groups: Group[];
  entityId: string;
  name: string;
};

const buildInput = (
  entityId: string,
  workspaceId: string,
  added: { id: string }[],
  removed: { id: string }[]
) => ({
  input: {
    addedGroups: added,
    removedGroups: removed,
    assetIds: [entityId],
    workspaceId,
  },
});

export const AssetGroupsButton = ({
  groups,
  entityId,
  name,
}: GroupsButtonProps) => {
  const workspace = useCurrentWorkspace(true);

  if (!workspace?.id) return <></>;

  return (
    <GroupAssignmentColumn
      entityId={entityId}
      entityName={name}
      currentGroups={groups}
      workspaceId={workspace.id}
      mutation={UPDATE_ASSETS_GROUPS}
      buildInput={buildInput}
      cacheKey="asset"
    />
  );
};
